import { render } from "./popup-base.vue?vue&type=template&id=b1cc7cc6&scoped=true"
import script from "./popup-base.vue?vue&type=script&lang=js"
export * from "./popup-base.vue?vue&type=script&lang=js"

import "./popup-base.vue?vue&type=style&index=0&id=b1cc7cc6&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1cc7cc6"]])

export default __exports__